import(/* webpackMode: "eager" */ "/vercel/path0/app/resources/case-studies/construction-infrastructure/page.tsx");
